export const CURRENT_ACCOUNT_KEY = 'current-account';
export const LAST_SELECTED_LANGUAGE = 'lastSelectedLanguage';
export const LAST_SELECTED_DASHBOARD = 'lastSelectedDashboard';
export const LAST_SELECTED_ACCOUNT_SETTINGS = 'lastSelectedAccountSettings';
export const LAST_CLOSED_SC_DEMO_OVERLAY = 'lastClosedScDemoOverlay';
export const CLOSED_USER_CREATION_WARNING_FORM =
  'closedUserCreationWarningForm';
export const CLOSED_USER_CREATION_WARNING_IMPORT =
  'closedUserCreationWarningImport';
export const CLOSED_USER_CREATION_WARNING_SYNC =
  'closedUserCreationWarningSync';
export const ACCOUNT_API_USE_LEGACY_INTERFACE = 'accountApiUseLegacyInterface';

export const FREE_TRIAL_ACTIVE_DAYS = 30;

export const DashboardType = {
  ADMIN: 'admin',
  LEARNER: 'learner',
};
